const listaDesplegable = (data) => {
  switch (data) {
    case "ADMIN":
      return true
    case "ADMINALIANZA":
      return [
        'ADMINALIANZA',
        'GERENTEALIANZA',
        'COORDINADORALIANZA',
        'SUPERVISORALIANZA',
        'OPERADORSERVICIOSALIANZA',
        'ASEGURADORAALIANZAS',
        'ASISTENCIADORAALIANZAS'
      ];
    case "GERENTEALIANZA":
      return [
        'COORDINADORALIANZA',
        'SUPERVISORALIANZA',
        'OPERADORSERVICIOSALIANZA',
        'WORKFORCE'
      ]
    case "COORDINADORALIANZA":
      return [
        'SUPERVISORALIANZA',
        'OPERADORSERVICIOSALIANZA'
      ]
    case "SUPERVISORALIANZA":
      return [
        'OPERADORSERVICIOSALIANZA'
      ]
    case "OPERADORSERVICIOSALIANZA": return false
  }
};

module.exports = listaDesplegable;
